import React, {Component} from 'react'

import './CListingDetails.css';
import {Card, Form} from 'react-bootstrap';
import Select from 'react-select';

import CListingAdminAction from './CListingAdminAction';
import CListingCustomization from './CListingCustomization';
import ApiV0 from '../services/ApiV0';
import EventEmitter from '../services/EventEmitter';
import {CConstants} from '../_common/CConstants';
import CPrice from '../_common/CPrice';
import {analyticsEvent} from '../_common/AnalyticsManager';
import {withTranslation} from 'react-i18next';

import {decode} from 'html-entities';
import CLoadInProgress from "../_common/CLoadInProgress";
import {isSet} from "../services/commonUtil.js";

const DEBUG_LISTING_DETAILS = false;

class CListingDetails extends Component {
    constructor(props) {
        super(props);
        const lang = ApiV0.getLang();
        this.state = this.getStateFromLang(lang);
    }

    getStateFromLang(lang = 'fr') {
        const productVariationKey = this.props.listing.has_variations === true ? this.getDefaultVariationKey(this.props.listing) : null;
        const productVariationKeyLabel = this.props.listing.has_variations ? this.getDefaultVariationKey(this.props.listing, lang) : null;
        const productVariationValues = productVariationKey ? this.getVariationValues(this.props.listing, productVariationKey, lang) : [];
        const defaultValue = null
        /*
        // select default variation
        var defaultValue = productVariationKey ? this.getDefaultVariationValue(this.props.listing, productVariationKey) : null;
        if (defaultValue !== null && this.props.onSelectVariation) { // default image
           var vImage = this.getVariationImage(this.props.listing, productVariationKey, defaultValue);
           this.props.onSelectVariation(productVariationKey, defaultValue, vImage, false);
        }
        */
        return {
            productVariationKey,
            productVariationKeyLabel,
            hasVariations: this.props.listing.has_variations === true && productVariationKey !== null,
            customizationConfig: this.props.listing.customization_config,
            hasCustomization: isSet(this.props.listing.customization_config),
            productVariationValues,
            currentValue: defaultValue,
            currentCustomization: null,
            updatingQuantity: false,
            showAdmin: false
        }
    }

    handleLangChange(event) {
        // console.log("lang has changed to", event.detail.newLang);
        const newState = this.getStateFromLang(ApiV0.getLang());
        newState.currentCustomization = null;
        this.setState(newState);
    }

    handleToggleAdminChange(event) {
        this.setState({showAdmin: !this.state.showAdmin});
    }

    handleSlideImage(event) {
        const userGenerated = true;
        const imageId = event?.detail?.imageId;
        const variationValue = this.getVariationValueFromImageId(imageId);
        if (isSet(variationValue)) {
            DEBUG_LISTING_DETAILS && console.log(`CListingDetails slide to imageId:${imageId} => variationValue:${variationValue}`);
            this.setListingVariantValue(variationValue, userGenerated)
        }
    }

    componentDidMount() {
        document.body.addEventListener(EventEmitter.CH_SET_LANG, this.handleLangChange.bind(this));
        document.body.addEventListener(EventEmitter.CH_TOGGLE_ADMIN, this.handleToggleAdminChange.bind(this));
        document.body.addEventListener(EventEmitter.CH_SLIDE_IMAGE, this.handleSlideImage.bind(this));
    }

    componentWillUnmount() {
        document.body.removeEventListener(EventEmitter.CH_SET_LANG, this.handleLangChange.bind(this));
        document.body.removeEventListener(EventEmitter.CH_TOGGLE_ADMIN, this.handleToggleAdminChange.bind(this));
        document.body.removeEventListener(EventEmitter.CH_SLIDE_IMAGE, this.handleSlideImage.bind(this));
    }

    addToCart() {
        const {t, title} = this.props;
        const hasCustomization = this.state.hasCustomization;
        const hasVariations = this.state.hasVariations;
        const listingId = this.props.listing.listing_id;
        const matchingCart = this.getMatchingCart();
        const isAlreadyInTheCart = (matchingCart && matchingCart.quantity > 0);
        const quantityInTheCart = isAlreadyInTheCart ? matchingCart.quantity : 0;
        // DEBUG // console.log("matchingCart", matchingCart, "isAlreadyInTheCart", isAlreadyInTheCart, "quantityInTheCart",quantityInTheCart)
        const toAddQuantity = this.state.wantedQuantity > 0 ? this.state.wantedQuantity : 1;
        const quantity = isAlreadyInTheCart ? toAddQuantity + quantityInTheCart : toAddQuantity;
        this.setState({updatingQuantity: true}, () => {
            ApiV0.addToCart(listingId, quantity, this.state.productVariationKey, this.state.currentValue, this.state.currentCustomization)
                .then(cart => {
                    DEBUG_LISTING_DETAILS && console.log('add cart', cart);
                    this.props.onCartUpdated(`Article ${title} ${t('listing.details.cartAdded')}`);
                    const evt = hasCustomization ? `addCart  ${quantity} ${listingId} ${title} customized` :
                        hasVariations ? `addCart  ${quantity} ${listingId} ${title} ${this.state.productVariationKey} ${this.state.currentValue}` :
                            `addCart  ${quantity} ${listingId} ${title}`;
                    // DEBUG // console.log(evt)
                    analyticsEvent(CConstants.GG_CATEGORY.LISTING, evt, evt);
                    let newState = (hasCustomization) ?
                        {// customization added to cart, need to reset previous selected value
                            updatingQuantity: false,
                            "wantedQuantity": null,
                            currentCustomization: null,
                            productVariationKey: null,
                            productVariationKeyLabel: null,
                            productVariationValues: []
                        } : {
                            updatingQuantity: false,
                            "wantedQuantity": 1
                        };
                    this.setState(newState);
                })
                .catch((error) => {
                    console.error('add cart error:', error);
                    this.props.onCartError(t('listing.details.error.cantAdd'));
                    this.setState({updatingQuantity: false});
                })
        });
    }

    _(toDecode) {
        return decode(toDecode);
    }

    getFirstVariationKey(listing) {
        return Object.keys(listing.products[0].values)[0];
    }

    getVariationValueFromImageId(imageId) {
        const {listing} = this.props;
        for (const p of listing.products) {
            const productKeys = Object.keys(p.values);
            for (const pk of productKeys) {
                const pkValues = p.values[pk];
                const pkValuesKeys = Object.keys(pkValues);
                if (pkValues[pkValuesKeys[0]]?.image_id === imageId) {
                    return pkValuesKeys[0];
                }
            }
        }
    }

    getDefaultVariationKey(listing, lang = null) {
        if (!listing.products || listing.products.length < 1) {
            return null;
        }
        const firstAvailable = listing.products.find(p => p.quantity > 0);
        if (lang === 'en' && firstAvailable && firstAvailable.en_values) {
            return Object.keys(firstAvailable.en_values)[0];
        }
        if (firstAvailable && firstAvailable.values) {
            return Object.keys(firstAvailable.values)[0];
        }
        return null;
    }

    getVariationValues(listing, key, lang = null) {
        const {t} = this.props;
        const unavailable = t('listing.details.variationUnavailable');
        const productWithThatKey = listing.products.filter(p => key in p.values || key in p.en_values);

        return productWithThatKey.map(p => {
            const values = key in p.values ? p.values : p.en_values;
            const value = Object.keys(values[key])[0];
            const i18label = value; // ETSY V3 NOT AVAILABLE
            const label = i18label + (p.quantity > 0 ? "" : ` (${unavailable})`);
            const isDisabled = (p.quantity < 1);
            const image_id = values[key][value]["image_id"];
            const price_raw = p.price_raw;
            const price_code = p.price_code;
            const quantityMax = p.quantityMax;
            const quantity = p.quantity;
            return {label, value, image_id, isDisabled, price_raw, price_code, quantity, quantityMax};
        });
    }

    getProducts(listing, variationKey, variationValue) {
        const varValues = this.getVariationValues(listing, variationKey);
        return varValues.find(v => v.value === variationValue);
    }

    getVariationImage(listing, key, value) {
        const selProduct = this.getProducts(listing, key, value);
        return selProduct !== undefined ? selProduct.image_id : null;
    }

    getMatchingProducts(listing) {
        return this.getProducts(listing, this.state.productVariationKey, this.state.currentValue);
    }

    getProductPrice(listing) {
        if (!this.state.currentValue) {
            return null;
        }
        const matchingProducts = this.getMatchingProducts(listing);
        return (!matchingProducts || !isSet(matchingProducts.price_raw)) ?
            null : (<CPrice price={matchingProducts.price_raw} currency={matchingProducts.price_code}/>);
    }

    getVariationProductQuantity(listing) {
        if (!this.state.currentValue || this.state.currentValue === "null") {
            return null;
        }
        const matchingProducts = this.getMatchingProducts(listing);
        return matchingProducts.quantityMax ? Math.min(matchingProducts.quantity, matchingProducts.quantityMax) :
            matchingProducts.quantity;
    }

    setListingVariantValue(variantValue, userGenerated) {
        DEBUG_LISTING_DETAILS && console.info("setVariantValue", variantValue, userGenerated);
        this.setState({currentValue: variantValue})
        if (this.props.onSelectVariation) {
            const vImage = this.getVariationImage(this.props.listing, this.state.productVariationKey, variantValue);
            this.props.onSelectVariation(this.state.productVariationKey, variantValue, vImage, userGenerated);
        }
    }

    handleChangeFromVariationBox(selectedOption) {
        this.setListingVariantValue(selectedOption.value, true);
    }

    handleCustomizationWorking() {
        this.setState({updatingQuantity: true});
    }

    handleCustomizationChange(newCustomization) {
        const currentCustomization = isSet(newCustomization) ? JSON.stringify(newCustomization) : null;
        this.setState({currentCustomization, updatingQuantity: false});
    }

    getMatchingCart() {
        return this.props.cartFindEntry(this.props.listing.listing_id, this.state.productVariationKey,
            this.state.currentValue, this.state.currentCustomization);
    }

    getMatchingCustomizationCount() {
        return this.props.cartEntryQuantity(this.props.listing.listing_id);
    }

    changeWantedQuantity(event) {
        const newValue = event.value || event.target.value;
        // DEBUG_LISTING_DETAILS && console.info("changeWantedQuantity", newValue, typeof newValue);
        this.setState({wantedQuantity: parseInt(newValue, 10)});
    }

    toggleAdmin() {
        EventEmitter.emitToggleAdmin();
    }

    render() {
        if (this.state.updatingQuantity) {
            return <CLoadInProgress/>;
        }
        const {t, isAdmin, title} = this.props;
        const hasVariations = this.state.hasVariations;
        const hasCustomization = this.state.hasCustomization;
        const customizationConfig = this.state.customizationConfig;
        const showAdmin = this.state.showAdmin;
        const listing = this.props.listing;
        const productCurrentPrice = this.getProductPrice(listing);
        const productCurrentQuantity = hasVariations && !isSet(productCurrentPrice) ? 0 :
            hasVariations ? Math.min(this.getVariationProductQuantity(listing), listing.quantity) :
                listing.quantity;
        const isConnected = this.props.isConnected;
        const matchingCart = this.getMatchingCart();
        const matchingCustomizationCount = this.getMatchingCustomizationCount();
        const matchingCartQuantity = hasCustomization ? matchingCustomizationCount :
            matchingCart && isSet(matchingCart.quantityMax) ? Math.min(matchingCart.quantity, matchingCart.quantityMax) :
                matchingCart ? matchingCart.quantity : 0;
        const isAlreadyInTheCart = (matchingCart && matchingCartQuantity > 0);
        const quantityInTheCart = isAlreadyInTheCart ? matchingCartQuantity : 0;
        const stayingQuantity = isAlreadyInTheCart ? productCurrentQuantity - quantityInTheCart : productCurrentQuantity;
        const quantityToSet = isSet(this.state.wantedQuantity) ? this.state.wantedQuantity : 1;
        const curSelectedVal = this.state.productVariationValues.find(f => f.value === this.state.currentValue);
        const canAddMoreProduct = stayingQuantity >= 1;
        const submitDisabled = (!canAddMoreProduct && stayingQuantity !== 1);
        const customConfig = customizationConfig ? JSON.parse(customizationConfig) : null;
        DEBUG_LISTING_DETAILS && console.log({
            matchingCart, isConnected, isAlreadyInTheCart, productCurrentQuantity,
            stayingQuantity, hasVariations, hasCustomization
        });

        const listingTitle = (
            <div className="clistingTitle">
                <span itemProp="name">{title}</span>
            </div>
        );

        const variationSelectBox = hasVariations ? (
            <div className="clistingVariationBox">
                {this.state.productVariationKeyLabel} :
                <Select placeholder={t('listing.choose')}
                        options={this.state.productVariationValues}
                        value={curSelectedVal} onChange={this.handleChangeFromVariationBox.bind(this)}
                        isOptionDisabled={(option) => option.isDisabled}
                        isSearchable={false}/>
            </div>
        ) : null;

        const variationCurrentPrice = hasVariations && productCurrentPrice ? (
            <div className="clistingPriceBox">
                {/* <div className="clistingPriceLabel">{t('listing.details.price')}</div> */}
                <div className="clistingPrice">{productCurrentPrice}</div>
            </div>
        ) : null;

        const listingPrice = hasVariations ? (
            <div>
                {variationCurrentPrice}
                {variationSelectBox}
            </div>
        ) : hasCustomization && stayingQuantity > 0 ? (
            <div className="clistingPriceBox">
                <div className="clistingPrice"><CPrice price={listing.price} currency={listing.currency_code}/></div>
                <CListingCustomization config={customConfig} value={listing.customization}
                                       onChange={this.handleCustomizationChange.bind(this)}
                                       onWorking={this.handleCustomizationWorking.bind(this)}/>
            </div>
        ) : (
            <div className="clistingPriceBox">
                {/* <div className="clistingPriceLabel">{t('listing.details.price')}</div> */}
                <div className="clistingPrice"><CPrice price={listing.price} currency={listing.currency_code}/></div>
            </div>
        )

        let listingCartButton = null;
        const listingCartNotice = isAlreadyInTheCart ?
            (<div className="detailsTips">
                {quantityInTheCart} {t('listing.details.inYour')} <a href="/cart"
                                                                     className="txt">{t('listing.details.cart')}</a>
            </div>) : null;

        if (hasCustomization && productCurrentQuantity > 0 && canAddMoreProduct && this.state.currentCustomization === null) {// personnalisez
            listingCartButton = (<div className="detailsTips">{t('listing.details.doCustomize')}</div>);
        } else if (hasVariations && this.state.currentValue === null) {// choisissez
            listingCartButton = null;
        } else if (productCurrentQuantity <= 0 || !canAddMoreProduct) {
            listingCartButton = (<div className="detailsTips">{t('listing.details.productUnavailable')}</div>);
        } else {// productCurrentQuantity > 0
            const quantityOptions = [...Array(stayingQuantity).keys()].map((val, index) => {
                return {"value": val+1, "label": val+1}
            })
            listingCartButton = this.state.updatingQuantity === false
            && ((!isAlreadyInTheCart) || canAddMoreProduct) ? (
                <>
                    <div className="clistingButtonBox">
                        <Form>
                            <div className="clistingPriceBox">
                                {!hasCustomization && canAddMoreProduct ? (<>
                                    {t('listing.details.quantity')}&#160;:<br/>
                                    <Select placeholder={t('listing.details.quantity')}
                                            options={quantityOptions}
                                            value={quantityOptions.find(o => o.value === quantityToSet)}
                                            defaultValue={quantityToSet}
                                            onChange={this.changeWantedQuantity.bind(this)}
                                            isSearchable={false}
                                            className="chComboQuantitySelect"
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    width: 80,
                                                }),
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: 'transparent',
                                                    borderColor: state.isFocused ? '#ccc' : '#666',
                                                    boxShadow: 'none',
                                                }),
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    padding: '0 6px',
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    padding: '0 4px',
                                                }),
                                                indicatorSeparator: () => ({ display: 'none' }), // supprime la barre verticale
                                            }}
                                    />
                                </>) : null}

                                {!isAlreadyInTheCart || canAddMoreProduct ? (
                                    <button type="button"
                                            className="btn btn-secondary btn-cart"
                                            onClick={this.addToCart.bind(this)}
                                            disabled={submitDisabled}
                                            title={t('listing.details.doAddToCart')}
                                    >{t('listing.details.doAddToCart')}</button>
                                ) : null}
                            </div>
                        </Form>
                    </div>
                </>
            ) : null;
        }
        return (
            <>
                <Card style={{width: '18rem'}} className="clistingDetails">
                    {listingTitle}
                    {listingPrice}
                    {listingCartButton}
                    {listingCartNotice}
                    {isAdmin && (<div className="toggleAdmin" onClick={() => this.toggleAdmin()}>admin</div>)}

                    {/* DEBUG
                    <pre>
                    quantityInTheCart:{quantityInTheCart}<br/>
                    productCurrentQuantity:{productCurrentQuantity}<br/>
                    stayingQuantity:{stayingQuantity}<br/>
                    isAlreadyInTheCart:{isAlreadyInTheCart ? "YES" : "NO"}<br/>
                    canAddMoreProduct:{canAddMoreProduct ? "YES" : "NO"}<br/>
                    </pre> */}

                    <CListingAdminAction
                        isAdmin={showAdmin && isAdmin}
                        listing={listing}
                    />
                    {/* JSON.stringify(this.state) */}
                </Card>
            </>
        );
    }
}

export default withTranslation('common')(CListingDetails);